import React from 'react';
import { TipoOficina, TipoVeiculo } from '../../../interfaces/OrcamentoCilia';
// Reuso do seletor de opção em cartão do relatório de veículos — nenhum CSS novo (catálogo de UI).
import '../../../components/modal/car-report/CarsReportModal.css';

export interface EscolhaParcial {
  tipoOficina: TipoOficina | null;
  tipoVeiculo: TipoVeiculo | null;
}

interface Props {
  valor: EscolhaParcial;
  onChange: (valor: EscolhaParcial) => void;
  /** O que veio pré-marcado pelo XML — a tela diz de onde veio, para ninguém confirmar no automático. */
  sugestao: EscolhaParcial;
  desabilitado?: boolean;
}

const OFICINAS: Array<{ valor: TipoOficina; rotulo: string }> = [
  { valor: 'INTERNA', rotulo: 'Oficina interna (Atual)' },
  { valor: 'EXTERNA', rotulo: 'Oficina parceira' },
];

const VEICULOS: Array<{ valor: TipoVeiculo; rotulo: string }> = [
  { valor: 'CARRO', rotulo: 'Carro' },
  { valor: 'MOTO', rotulo: 'Moto' },
];

/**
 * Onde o veículo está e que veículo é (at-14, ADR 0009). É o que decide o centro de custo, a
 * classificação financeira e o local de estoque com que a requisição nasce no Nasajon.
 *
 * ⚠️ A pré-seleção vem do servidor e só existe quando o XML decide (CNPJ da oficina própria ⇒
 * interna; "Automóvel" ⇒ carro). Sem ela, nada vem marcado e o "Concluir" fica bloqueado: decidir
 * por ausência seria chutar o centro de custo.
 */
const EscolhaDoDestino: React.FC<Props> = ({ valor, onChange, sugestao, desabilitado }) => {
  const grupo = <T extends string>(
    nome: string,
    opcoes: Array<{ valor: T; rotulo: string }>,
    atual: T | null,
    aoEscolher: (v: T) => void,
  ) => (
    <div className="report-formato-linha" role="radiogroup" aria-label={nome}>
      {opcoes.map((o) => (
        <label key={o.valor} className={`checkbox-label ${atual === o.valor ? 'active' : ''}`}>
          <input
            type="radio"
            name={nome}
            value={o.valor}
            checked={atual === o.valor}
            disabled={desabilitado}
            onChange={() => aoEscolher(o.valor)}
          />
          <span>{o.rotulo}</span>
        </label>
      ))}
    </div>
  );

  const veioDoXml = Boolean(sugestao.tipoOficina || sugestao.tipoVeiculo);

  return (
    <div>
      <p>
        <strong>Onde o veículo está</strong>
      </p>
      {grupo('Onde o veículo está', OFICINAS, valor.tipoOficina, (v) => onChange({ ...valor, tipoOficina: v }))}
      <p>
        <strong>Tipo de veículo</strong>
      </p>
      {grupo('Tipo de veículo', VEICULOS, valor.tipoVeiculo, (v) => onChange({ ...valor, tipoVeiculo: v }))}
      <p className="solicitacao-arquivo-hint">
        A escolha define o centro de custo, a classificação financeira e o local de estoque com que a
        requisição nasce no Nasajon.
        {veioDoXml && ' O que veio marcado foi lido do arquivo do Cilia — confira antes de concluir.'}
      </p>
    </div>
  );
};

export default EscolhaDoDestino;
